import _classCallCheck from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import styled from 'styled-components';
import ImageTextCard from '../../molecules/ImageTextCard';
import Anchor from '../../atoms/Anchor';
import { blogLabels } from '../../../constants/labels/en';
import analyticsConstants from '../../../constants/analyticsConstants';
import styles from './BlogListTile.style';
var BlogListTile = /*#__PURE__*/function (_Component) {
  _inherits(BlogListTile, _Component);
  var _super = _createSuper(BlogListTile);
  function BlogListTile(props) {
    _classCallCheck(this, BlogListTile);
    return _super.call(this, props);
  }
  _createClass(BlogListTile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        featured = _this$props.featured,
        tile = _this$props.tile;
      var tileClasses = ['nva-blog-list-tile', 'blog-tile'];
      if (className.length > 0) {
        tileClasses.push(className);
      }
      if (featured) {
        tileClasses.push('nva-blog-list-tile--featured featured-blog');
      } else {
        tileClasses.push('nva-blog-list-tile--normal normal-blog');
      }
      return __jsx("div", {
        className: tileClasses.join(' ')
      }, __jsx(Anchor, {
        className: "nva-blog-list-tile__image-text-card",
        title: tile.headingText,
        to: tile.ctaURL,
        "data-analytics-type": analyticsConstants.blogList.analyticsType.BLOG_CTA,
        "data-analytics-value": tile.headingText,
        "data-analytics-variation": ""
      }, __jsx(ImageTextCard, tile)), __jsx(Anchor, {
        className: "nva-blog-list-tile__read-more",
        to: tile.ctaURL,
        styleType: "primary-anchor",
        title: tile.headingText,
        "aria-label": blogLabels.READ_MORE,
        "data-analytics-type": analyticsConstants.blogList.analyticsType.BLOG_CTA,
        "data-analytics-value": tile.headingText,
        "data-analytics-variation": ""
      }, blogLabels.READ_MORE));
    }
  }]);
  return BlogListTile;
}(Component);
_defineProperty(BlogListTile, "defaultProps", {
  className: '',
  featured: false
});
export default styled(BlogListTile).withConfig({
  componentId: "sc-1rwaidm-0"
})(["", ";"], styles);
export { BlogListTile };